import { createSourceL10n, defineLazyL10n } from '$lib/i18n';
import enUS from './locales/en-US.json';

const NS = 'components';
const loaders = import.meta.glob<{ default: Record<string, string> }>('./locales/*.json');

export const { l10n, ns, preload } = defineLazyL10n(loaders, NS, enUS);
export const sourceL10n = createSourceL10n(NS);
